import {Layout} from "./Layout.js";

export class CompanyInfoLayout extends Layout {
    template() {
        const {sectionId = '' , companyName = '', employeeList = []} = this.$props;
        return `
                <section id="${sectionId}" class="signup-wide-pop">
                    <header class="js-section-header"></header>
                    <article>
                        <div class="pop-main js-contents-main">
                            ${this.getMainTextTemplate()}
                            ${this.getSubTextTemplate()}
                            <div class="company-info-read-wrap">
                                <em>${companyName}</em>
                                <div>${this.getProfileContents(employeeList)}</div>
                                <p>${this.getNameContents(employeeList)}</p>
                                ${this.getNexPageButtonTemplate()}
                              </div>
                        </div>
                    </article>
                </section>`
    }

     getProfileContents(employeeList = []) {
        if (employeeList.length === 0) {
            return '';
        }
        return employeeList.map((employee) => this.getProfilePhotoTemplate(employee.PRFL_PHTG))
            .join(" ");
    }

     getProfilePhotoTemplate(profilePhotoUrl = '') {
        const defaultImageUrl = "/flow-renewal/assets/images/profile-default.png";
        return `<p class="js-profile user-img" style="background-image: url(${profilePhotoUrl})  , url(${defaultImageUrl}) ;"></p>`
    }

     getNameContents(employeeList = []) {
        if (employeeList.length === 0) {
            return '';
        }
        return employeeList.map((employee) => {
            if(Mutil.empty(employee.FLNM)) {
                return '';
            }
            return `<span>${employee.FLNM}</span>`;
        }).join(", ") + ` ${i18next.t(login.participating)}`;
    }

}